import { VisualBrick, registerBrick } from 'olympe';
import { combineLatestWith } from 'rxjs/operators';

export default class VisualRepeater extends VisualBrick {

    /**
     * @override
     */
    init($) {
        $.set('div', document.createElement('div'));
    }

    /**
     * @override
     */
    setupExecution($) {
        return $.observe('Hidden').pipe(combineLatestWith($.observe('renderer', false)));
    }

    /**
     * @override
     */
    render($, [hidden, renderer]) {
        const parent = $.get('div');
        if(!hidden && renderer) {
            const renderer$ = $.runner(renderer).setParentElement(parent);
            this.getPropertiesToRepeat().forEach(prop => {
                renderer$.repeat(prop, $.observe(prop));
            });
            this.getEventsToForward().forEach(event => {
                renderer$.observe(event).subscribe($.trigger.bind(event));
            });
        }
        return parent;
    }

    /**
     * @protected
     * @return {!Array<string>}
     */
    getPropertiesToRepeat() {
        return [
            'Allow Content Overflow',
            'Border Color',
            'Border Radius',
            'CSS Property',
            'Default Color',
            'Height',
            'Tab Index',
            'Width',
            'Z-Index'
        ];
    }

    /**
     * @protected
     * @return {!Array<string>}
     */
    getEventsToForward() {
        return ['On Click'];
    }
}

registerBrick('018810221880450f7363', VisualRepeater);
